import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../Layout/Header";
import SideBar from "../Layout/SideBar";
import "datatables.net-dt";
import $ from "jquery";
import { baseURL } from "../../axios/common";

const ListReviews = () => {
  const [reviews, setReviews] = useState(null); // Start with null to detect loading state

  useEffect(() => {
    fetchReviews();
  }, []);

  useEffect(() => {
    if (reviews && reviews.length > 0) {
      if (!$.fn.DataTable.isDataTable("#ReviewTable")) {
        $("#ReviewTable").DataTable();
      }
    }
  }, [reviews]);

  const fetchReviews = async () => {
    try {
      const response = await axios.post(
        baseURL + "admin/getReviews",
        { page: 1, limit: 10, language: "en" },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      setReviews(response.data.data || []);
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviews([]); // Handle errors by setting an empty array
    }
  };

  return (
    <div>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid"></div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h2 className="card-title">Reviews</h2>
                    </div>
                    <div className="card-body">
                      <table id="ReviewTable" className="table table-striped" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Reviewer</th>
                            <th>Review</th>
                            <th>Rating</th>
                            <th>Activity</th>
                            <th>Creator</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reviews === null ? (
                            <tr>
                              <td colSpan="6" className="text-center">Loading reviews...</td>
                            </tr>
                          ) : reviews.length === 0 ? (
                            <tr>
                              <td colSpan="6" className="text-center">No reviews found</td>
                            </tr>
                          ) : (
                            reviews.map((review, index) => (
                              <tr key={review.id}>
                                <td>{index + 1}</td>
                                <td>{review.reviewer_name}</td>
                                <td>{review.review}</td>
                                <td>{review.rating}</td>
                                <td>{review.activity_name}</td>
                                <td>{review.creator_name}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default ListReviews;
